import React from 'react';
import SearchMedicamentRecordListItemMedicament, {
	SearchMedicamentRecordListItemMedicamentScheme,
} from './SearchMedicamentRecordListItemMedicament';
// @ts-ignore
import styles from './SearchMedicamentRecordListItem.module.scss';

export interface SearchMedicamentRecordListItemScheme {
	title: string;
	children: SearchMedicamentRecordListItemMedicamentScheme[];
}

interface Props {
	item: SearchMedicamentRecordListItemScheme;
	onIssueAgain?: (
		medicament: SearchMedicamentRecordListItemMedicamentScheme,
	) => void;
}

const SearchMedicamentRecordListItem: React.FC<Props> = ({
	item,
	onIssueAgain,
}) => {
	return (
		<>
			<div className={styles.title}>{item.title}</div>
			{item.children.map((child, index) => (
				<SearchMedicamentRecordListItemMedicament
					key={`${item.title}-${child.title}-${index}`}
					item={child}
					onIssueAgain={onIssueAgain}
				/>
			))}
		</>
	);
};

export default SearchMedicamentRecordListItem;
